import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('ro/inter-branch-transfer/drafts', { params })
  },

  async show (id) {
    return axios.get(`ro/inter-branch-transfer/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/inter-branch-transfer/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/inter-branch-transfer/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/inter-branch-transfer/drafts/${data.id}`, { data })
  }
}

export default DraftService
